import React, { useState } from "react";
import { useNavigate } from "react-router";

import SettingsTutorial from "../SettingsTutorial";
import BackBar from "../../../../common/nav/BackBar";
import { SonicProject } from "../../../../common/classes/SonicProject";
import SettingsItem from "../../../../common/mypage/user-settings/SettingsItem";

import ImageProject from "../../../../assets/img/project_setsumei.webp";

import styles from "../../../../common/mypage/user-settings/Settings.module.scss";

type Props = {
  projects: Array<SonicProject>;
};

const AppliedProjectList: React.FC<Props> = ({ projects }) => {
  const navigate = useNavigate();

  const [currentMenu, setCurrentMenu] = useState<number | null>(null);

  const toggleMenu = (i: number) => {
    if (i === currentMenu) {
      setCurrentMenu(null);
    } else {
      setCurrentMenu(i);
    }
  };
  return (
    <>
      <div className={styles["p-dbsettings"]}>
        <div className={styles["p-dbsettings__wrapper"]}>
          <BackBar
            title="応募済みプロジェクト"
            editable={false}
            handleClose={() => navigate(-1)}
          />
          <div className={styles["p-projectSettings__list"]}>
            <div className={styles["p-projectSettings__list-title"]}>
              応募済みプロジェクト一覧
            </div>
            {projects && projects?.length > 0 ? (
              projects.map((project, i) => (
                <SettingsItem
                  key={i}
                  page_type="プロジェクト"
                  id={project.id}
                  img_src={project?.imgs?.[0]?.thumbnail?.url}
                  name={project.name}
                  type={project.type}
                  applicants={project.applicants}
                  end_date={project.end_date}
                  status={project.status}
                  handleMenu={() => toggleMenu(i)}
                  detail_link={`/project/${project.id}`}
                  isMenuOpen={currentMenu === i ? true : false}
                  isOwner={false}
                  borderColorStyle={`#f79b00`}
                  typeTagStyle={project.type?.color}
                />
              ))
            ) : (
              <SettingsTutorial
                img_src={ImageProject}
                title="まだプロジェクトへの応募はございません。"
                explanation="気になるプロジェクト見つけて応募してみましょう！"
                link="/project"
                link_text="プロジェクト一覧ページへ"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AppliedProjectList;
